import { render, staticRenderFns } from "./RoadRescueFund.vue?vue&type=template&id=0361d048"
import script from "./RoadRescueFund.vue?vue&type=script&lang=js"
export * from "./RoadRescueFund.vue?vue&type=script&lang=js"
import style0 from "./RoadRescueFund.vue?vue&type=style&index=0&id=0361d048&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports